/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';

class DomainViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, domainService, waitSpinnerService, $q, $state, $stateParams, $log,
        notificationService, $mdDialog, data) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.domainService = domainService;
        this.$mdDialog = $mdDialog;
        this.domain = data.domain;
        this.$log.debug('Controller \'DomainViewController\' loaded');
        // Angular Material does not support Angular $onInit hook for controllers yet
        // (see https://github.com/angular/material/issues/9259)
        // That's why it is simulated hereafter. This code shall be removed if the issue above is fixed (expected in
        // Angular Material 1.2.0)
        this.initialized = false;
        this.$onInit();
    }

    $onInit() {
        if (this.initialized) {
            this.$log.warn('DomainViewController.$onInit called twice: issue 9259 may have been fixed');
        } else {
            super.$onInit();

            if (this.domain.id) {
                this.updateMode = true;
                this.title = 'ui.domain.update';
            } else {
                this.updateMode = false;
                this.title = 'ui.domain.create';
                this.domain = {
                    parks: []
                };
            }
            this.formDisabled = false;
            this.initialized = true;
        }
    }

    save() {
        this.formDisabled = true;
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.domainService.updateEntity(this.domain);
        } else {
            serviceActionPromise = this.domainService.createEntity(this.domain);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.domain.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            this.$mdDialog.hide();
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    cancel() {
        this.$mdDialog.hide();
    }
}

export { DomainViewController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/component/DomainView.js